import React from 'react';
import { connect } from 'react-redux';
import AccordionTitleRskn from './accordionTitleRskn';
import { InHomeUtils } from './../../util/inhomeUtils';
import ProductContainer from './productContainer'
import { parentAccordionFocusAnimate, focusAnimation, removeUnSelectedManualOffers, removeFlashOffers } from './../../action/buildProduct';
import { Service } from './../../constants/actionType';

class MM3InternetSubPlan extends React.PureComponent {
    constructor(props) {
        super(props);
    this.splOfferAccordionRef = React.createRef();
    this.disableReskin = true
    this.isReskin = this.disableReskin && this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    componentDidUpdate () {
        if (((!this.props.isSubOffer && this.props.buildProduct.focusParentAccordion) || (this.props.isSubOffer && this.props.buildProduct.focusAccordion && this.checkAccordionStatus())) && this.props.sploffer.isAccordionOpen) {
        if (this.splOfferAccordionRef) {
            parentAccordionFocusAnimate(this.props.dispatch);
            focusAnimation(this.splOfferAccordionRef.offsetTop - (this.props.isSubOffer ? 5 : 10));
            }
        }
    }
    checkAccordionStatus = () => {
        return (this.props.sploffer.isAccordionOpen && ((this.props.isDataOffer && !(this.props.buildProduct.internet.isSubAccordionOpen || this.props.buildProduct.router.isAccordionOpen || this.props.buildProduct.techsure.isAccordionOpen || this.props.buildProduct.fne.isAccordionOpen)) 
        || !(this.props.buildProduct.tv.isSubAccordionOpen || this.props.buildProduct.router.isAccordionOpen || this.props.buildProduct.vRoom.isAccordionOpen || this.props.buildProduct.recording.isAccordionOpen || this.props.buildProduct.dct.isAccordionOpen || this.props.buildProduct.channel.isAccordionOpen )))
    }

    render() {
        let parentAccordionStatus = this.props.isSubOffer ? this.props.buildProduct.mm3internetsub.subAccordionStatus : this.props.buildProduct.mm3internetsub.accordionStatus;
        let products = "";
        let displayStyle = "";
        let accordionImageSrc ="";
        let accordionInnerContent = '';
        let accordionContent = '';
        let accordionDisplayStyle = this.props.buildProduct.internet ? 'row padding-vert-zero bdr-b-black' : 'row padding-vert-zero bdr-b-black hide';
        let splPromoTitle = [];
        let promoOfferText = '';
        let promoTxt=[];
        let fcpPromoTxt='';
        let splOfferPrdDetail='';
        let selectedPrdDetail=[];
        let selectedServiceType='';
        if(this.props.sploffer.offerplansMTM!=null && this.props.sploffer.offerplansMTM.length===1 && InHomeUtils.isNotNull(this.props.sploffer.offerplansMTM.filter(p => p.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH")))
        {
            accordionDisplayStyle = 'row padding-vert-zero bdr-b-black';
        }
        if(this.props.isSubOffer){
            if(this.props.sploffer != null && this.props.sploffer.selectedProduct !== undefined  && this.props.sploffer.selectedProduct != null && 
                this.props.sploffer.selectedProduct.hasOwnProperty('offerAttrValue') &&  this.props.sploffer.selectedProduct.hasOwnProperty('offerAttr')) {
                   splOfferPrdDetail = this.props.sploffer.selectedProduct.offerAttrValue + '_' + this.props.sploffer.selectedProduct.offerAttr;
                } 
                else 
                {
                    if(this.props.sploffer != null && this.props.sploffer.selectedProduct !== undefined  &&  this.props.sploffer.selectedProduct != null && 
                   this.props.sploffer.selectedProduct.hasOwnProperty('BsOfferAttrValue') && this.props.sploffer.selectedProduct.hasOwnProperty('BsOfferAttr')) {
                       splOfferPrdDetail = this.props.sploffer.selectedProduct.BsOfferAttrValue + '_' + this.props.sploffer.selectedProduct.BsOfferAttr;
   
                   }
               }
               if(this.props.isDataOffer &&
                 InHomeUtils.isNotNull(this.props.buildProduct.internet)
                 && InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct)
                  && InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct.specialOffers)){
                selectedPrdDetail=this.props.buildProduct.internet.selectedProduct.specialOffers;
                selectedServiceType=Service.data;
               }
               else {
                   if(InHomeUtils.isNotNull(this.props.buildProduct.tv)
                   && InHomeUtils.isNotNull(this.props.buildProduct.tv.selectedProduct)
                    && InHomeUtils.isNotNull(this.props.buildProduct.tv.selectedProduct.specialOffers)){
                    selectedPrdDetail=this.props.buildProduct.tv.selectedProduct.specialOffers;
                    selectedServiceType=Service.video;
                   }  
                
               }
            let splOfferDetail=removeUnSelectedManualOffers(selectedPrdDetail, " ", selectedServiceType,splOfferPrdDetail);
            splOfferDetail=removeFlashOffers(splOfferDetail, selectedServiceType);
            if(InHomeUtils.isNotNull(splOfferDetail)){
                splOfferDetail.forEach(offer => { 
               if (InHomeUtils.isNotEmpty(offer.offerFor) && InHomeUtils.isNotEmpty(offer.OfferText) && offer.BsOfferAttrValue && offer.BsOfferAttrValue !== "SONY_PS5_ACQ_HS") {
                   promoOfferText = offer.OfferText;  
                   splPromoTitle.push(promoOfferText);      
               }  
                  
           });
        }
            
            if (promoTxt.length > 0) {
               promoTxt.map((promo)=>{
                if(promo === "Sony Gaming Offer")
                {
                    promo = "Sony DualSense Wireless Controller PS5";
                }
                   
                   fcpPromoTxt+=" + "+promo+" ";
                }) 
           } 
        }
       
        let sony_check = this.props.sploffer.selectedProduct && this.props.sploffer.selectedProduct.offerAttrValue && (this.props.sploffer.selectedProduct.offerAttrValue === "SONYPULSE3D_WLS_HEADSET_ACQ_HS" || this.props.sploffer.selectedProduct.offerAttrValue === "SONYPULSE3D_WLS_HEADSET_ACQ" || this.props.sploffer.selectedProduct.offerAttrValue === "SONY_PS5_ACQ") ? true : false;
        let accordionTitle = "Choose your plan extra";
        if (this.props.sploffer && this.props.sploffer.selectedProduct && this.props.sploffer.selectedProduct.OfferText && this.props.sploffer.selectedProduct.OfferText !== '') {
             accordionTitle = `${this.props.isSubOffer && this.props.isDataOffer? 'Internet Offer: ' : ''} ${ sony_check? "Sony Gaming Offer" : this.props.sploffer.selectedProduct.OfferText}${this.props.isSubOffer ? fcpPromoTxt :'' }`;
        }
       // if (this.props.sploffer.isAccordionOpen) {
            products = <ProductContainer products={this.props.buildProduct.mm3internetsub.offerplansMTM} style={{ displayStyle }}
                selectedProduct={this.props.buildProduct.mm3internetsub !== null && this.props.buildProduct.mm3internetsub !== undefined && this.props.buildProduct.mm3internetsub.selectedProduct !== null ? this.props.buildProduct.mm3internetsub.selectedProduct : null}
                voiceTN={this.props.requestTN !== undefined && this.props.requestTN !== null && this.props.requestTN !== '' ? this.props.requestTN : ''} modalWindow={this.props.modalWindow} 
                visitId={this.props.visitId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch} isSubOffer = {this.props.isSubOffer} isDataOffer = {this.props.isDataOffer} flowType={this.props.flowType}/>;
       // }
         accordionTitle=this.props.buildProduct.mm3internetsub.selectedProduct!==null && this.props.buildProduct.mm3internetsub.selectedProduct.id!==''?
         (this.props.buildProduct.mm3internetsub.selectedProduct.name||this.props.buildProduct.mm3internetsub.selectedProduct.prodName):"Choose your plan extra";
        accordionInnerContent = <div className="columns padding-all-zero">
                            <div className={this.isReskin ? "w_accordion borderTp" : "w_accordion"} id="specialofferAccordionBlock">
                                {this.isReskin && <hr className="hr_reskin" style={{borderTop:"1px solid #ccc "}} aria-hidden="true"/>}
                                <div className={ "accordion_blocks padding-top-zero"}>
                                    {this.isReskin && <AccordionTitleRskn isHidePromo={this.props.sploffer.isAccordionOpen ? 'true' : 'false'} title={accordionTitle} inputelementRef={this.props.inputRef}
                                        titleOmniName="Manage plan perks" name="toggle_datasub_accor" status={parentAccordionStatus} isAccordionOpen={this.props.sploffer.isAccordionOpen}
                                        isDoflow={this.props.isDoflow}></AccordionTitleRskn>}
                                    <div className={this.props.isSubOffer ? '' : 'showPad'}>
                                        <div data-reveal-content="zContractAndOffer" aria-hidden="false" className={this.props.sploffer.isAccordionOpen ? `row accordion_blocks-content m_post-offer ${this.props.isSubOffer ? '' : 'margin-vert-large'} border-left border-right border-bottom bg-white-active contract-accordion-open` : `row accordion_blocks-content m_post-offer ${this.props.isSubOffer ? '' : 'margin-vert-large'} border-left border-right border-bottom bg-white-active contract-accordion-close`}>
                                            <div className="row padding-all-zero margin-all-zero">
                                                <div className="columns padding-all-zero">
                                                    <div className="w_accordion">
                                                        <div className="accordion_blocks padding-top-zero">
                                                            <div className="row accordion_blocks-content" data-reveal-content="zInternetOptions" style={{ transition: 'opacity 300ms' }} hidden="">
                                                                {/* <div className="columns"> */}
                                                                    <div className="columns relative accordionChild">
                                                                        {accordionImageSrc}
                                                                        <div className="accordionTile">
                                                                            {products}
                                                                        </div>
                                                                    </div>
                                                                {/* </div>  */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

        if(this.props.isSubOffer) {
            let displayStyle = true;
            accordionContent = <div className={this.isReskin ? "row accordion_blocks-content margin-vert-large bg-white-active MargnSubAccor" : "row accordion_blocks-content margin-vert-large border-left border-right border-bottom bg-white-active"} style={{ transition:'opacity 300ms', display:''}} ref={(el) => this.splOfferAccordionRef = el}>
                                <div className="row padding-all-zero margin-all-zero">
                                {accordionInnerContent}
                                </div>
                            </div>
        }
        else {
            accordionContent = <div className={accordionDisplayStyle} ref={(el) => this.splOfferAccordionRef = el}>
                                    {accordionInnerContent}
                                </div>
        }
        
        return (
            <React.Fragment>
                {accordionContent}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
    }
}

export default connect(
    mapStateToProps
)(MM3InternetSubPlan);